import { apiFetch } from "@/integrations/backend/client";
import { formatLocalDateToYYYYMMDD } from "@/lib/date-only";

export type WorkoutTemplateMeta = {
  id: string;
  name: string;
  duration_minutes: number | null;
  category?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  creator_email?: string | null;
  exercise_count?: number;
  difficulty_counts?: Partial<
    Record<"Beginner" | "Intermediate" | "Advanced" | "Expert" | "Pro", number>
  >;
  primary_muscles_top?: string[];
};

export async function listTemplates(difficulty?: string): Promise<WorkoutTemplateMeta[]> {
  const url = difficulty && difficulty !== "All"
    ? `/api/v1/workouts/templates?difficulty=${encodeURIComponent(difficulty)}`
    : "/api/v1/workouts/templates";
  const res = await apiFetch(url, { method: "GET" });
  if (!res.ok) throw new Error(`templates_list_failed:${res.status}`);
  return (await res.json()) as WorkoutTemplateMeta[];
}

export async function createTemplate(name: string = "Untitled Workout", duration: number = 30): Promise<string> {
  const res = await apiFetch("/api/v1/workouts/templates", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, duration_minutes: duration, description: "" }),
  });
  if (!res.ok) throw new Error(`template_create_failed:${res.status}`);
  const json = await res.json();
  return json.id as string;
}

export async function getTemplateMeta(id: string): Promise<WorkoutTemplateMeta> {
  const res = await apiFetch(`/api/v1/workouts/templates/${id}/meta`, { method: "GET" });
  if (!res.ok) throw new Error(`template_meta_failed:${res.status}`);
  return (await res.json()) as WorkoutTemplateMeta;
}

export async function patchTemplateMeta(id: string, patch: Partial<{ name: string; duration_minutes: number }>): Promise<void> {
    const res = await apiFetch(`/api/v1/workouts/templates/${id}/meta`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(patch),
    });
    if (!res.ok) throw new Error(`template_patch_failed:${res.status}`);
}

export async function assignTemplateToUser(
  templateId: string,
  profileId: string,
  date: Date,
  difficultyLevels?: string[]
): Promise<string> {
  const res = await apiFetch(`/api/v1/workouts/templates/${templateId}/assign`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      profile_id: profileId,
      date: formatLocalDateToYYYYMMDD(date), // YYYY-MM-DD (local-safe)
      difficulty_levels: difficultyLevels,
    }),
  });
  if (!res.ok) throw new Error(`template_assign_failed:${res.status}`);
  const json = await res.json();
  return json.id as string;
}

export async function deleteTemplate(templateId: string): Promise<void> {
  const res = await apiFetch(`/api/v1/workouts/templates/${templateId}/delete`, {
    method: "POST",
  });
  if (!res.ok) throw new Error(`template_delete_failed:${res.status}`);
}


